import { render, staticRenderFns } from "./PayzenFormHeader.vue?vue&type=template&id=839594fc&scoped=true&"
import script from "./PayzenFormHeader.vue?vue&type=script&lang=js&"
export * from "./PayzenFormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839594fc",
  null
  
)

export default component.exports